module.exports = __webpack_public_path__ + "data-table.b0aebd744ce7adb780a9.svg";


//////////////////
// WEBPACK FOOTER
// /Users/abassey/side-proj/emp21-new/node_modules/@swimlane/ngx-datatable/release/assets/fonts/data-table.svg
// module id = ../../../../@swimlane/ngx-datatable/release/assets/fonts/data-table.svg
// module chunks = styles